import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Vashitopunecab() {



const cardData = {
  keyword: " Vashi to Pune Cabs",

headingDescription: "Velocity Cab provides reliable and comfortable Vashi to Pune cab services, ensuring a smooth and hassle-free journey for business trips, airport transfers, family outings, and leisure travel. Our professional drivers, well-maintained vehicles, and punctual pickups make traveling from Vashi to Pune convenient and stress-free. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Vashi to Pune cab travel.",

topPlaces: [
 
  {
    title: "Raja Dinkar Kelkar Museum",
    description: "Raja Dinkar Kelkar Museum is home to thousands of rare artifacts, traditional musical instruments, sculptures, and decorative objects representing India's rich cultural heritage. It offers an enriching experience for history and art enthusiasts."
  },
  {
    title: "Aga Khan Palace",
    description: "Aga Khan Palace is a magnificent heritage monument associated with India's freedom movement. Visitors can explore its elegant architecture, peaceful gardens, and museum dedicated to Mahatma Gandhi while learning about Pune's historical significance."
  },
  {
    title: "Pataleshwar Cave Temple",
    description: "Pataleshwar Cave Temple is an ancient rock-cut Shiva temple carved from a single basalt rock. Its tranquil surroundings and remarkable architecture make it a popular destination for spirituality, history, and photography."
  },
  {
    title: "Bund Garden",
    description: "Bund Garden is a scenic riverside park offering lush greenery, boating opportunities, and peaceful walking paths. It is a perfect place for families, couples, and nature lovers seeking relaxation."
  },
   {
    title: "Pune Okayama Friendship Garden",
    description: "Pune Okayama Friendship Garden, also known as Pu La Deshpande Garden, is a beautifully landscaped Japanese-style garden featuring serene ponds, lush greenery, and elegant walking paths. Travelers booking a sedan cab in Pune can enjoy peaceful strolls, scenic photography, and a relaxing escape from the city's busy streets."
  },
  {
    title: "Saras Baug",
    description: "Saras Baug is a popular recreational garden in Pune featuring beautifully maintained lawns and the famous Siddhivinayak Temple. Visitors can relax amidst nature, enjoy leisurely walks, and experience one of the city's favorite family-friendly destinations."
  },
  {
    title: "Parvati Hill",
    description: "Parvati Hill is one of Pune's oldest landmarks, offering panoramic city views from its historic temple complex. Travelers can climb the stone steps, visit ancient shrines, and enjoy breathtaking scenery."
  },
  {
    title: "Shaniwar Wada",
    description: "Shaniwar Wada is Pune's iconic historical fort and a symbol of the Maratha Empire. Visitors can explore its grand gateways, historic ruins, and captivating light and sound show that showcases the city's rich heritage."
  },
  {
    title: "Phoenix Marketcity Pune",
    description: "Phoenix Marketcity Pune is a premier shopping and entertainment destination featuring international brands, restaurants, cinemas, and family-friendly attractions, making it ideal for a day of leisure."
  },
  {
    title: "Khadakwasla Dam",
    description: "Khadakwasla Dam is a scenic getaway on the outskirts of Pune, popular for its peaceful waterfront views, beautiful sunsets, and relaxing atmosphere. It is an excellent destination for picnics and photography."
  }
],



services: [
{
name: "Vashi to Pune Cab",
description: "Vashi to Pune cab service offers smooth and reliable intercity travel from Navi Mumbai to Pune via the Mumbai–Pune Expressway. Travelers can choose from sedan, Ertiga, and Innova Crysta depending on comfort and group size. This route is widely used by IT professionals, corporate travelers, and families traveling between Vashi and Pune. Professional drivers ensure timely pickup from Vashi sectors, railway station, and nearby areas. Air-conditioned vehicles, clean interiors, and smooth highway driving ensure a comfortable journey. Online booking with instant confirmation and transparent pricing makes this service convenient and stress-free for every traveler."
},
{
name: "Vashi to Pune Taxi Fare",
description: "Vashi to Pune taxi fare service provides clear and transparent pricing based on vehicle type and travel requirements. Travelers can choose affordable sedan options or premium SUVs like Ertiga and Innova Crysta. Fare details include tolls, driver allowance, and per km charges, ensuring no hidden costs. This helps passengers plan their budget effectively for both one-way and round trip journeys."
},
{
name: "Vashi to Pune Taxi Service",
description: "Vashi to Pune taxi service offers comfortable and dependable travel between Navi Mumbai and Pune city. Travelers can enjoy smooth rides with professional drivers and well-maintained vehicles. Pickup is available from homes, offices, hotels, and railway stations in Vashi. This service is ideal for daily commuters, business trips, and weekend travel."
},
{
name: "Vashi to Pune One Day Cab",
description: "Vashi to Pune one day cab service is perfect for same-day return trips. Travelers can visit Pune for meetings, personal work, or short tours and return to Vashi the same day. Comfortable vehicles and experienced drivers ensure timely travel and flexible scheduling."
},
{
name: "Vashi to Pune Round Trip Cab",
description: "Vashi to Pune round trip cab service offers convenient two-way travel with flexible return options. Travelers can book vehicles for multi-day trips, family visits, or corporate travel. This service ensures comfort, reliability, and cost-effective pricing for return journeys."
},
{
name: "Vashi to Pune Ertiga Cab",
description: "Vashi to Pune Ertiga cab service provides spacious and comfortable travel for families and small groups. The Ertiga offers ample seating and luggage space, making it ideal for long-distance journeys. Professional drivers ensure smooth and safe travel."
},
{
name: "Vashi to Pimpri Chinchwad Cab",
description: "Vashi to Pimpri Chinchwad cab service offers direct transportation to PCMC areas including Pimpri, Chinchwad, and nearby locations. Travelers can enjoy convenient travel with door-to-door pickup and drop service."
},
{
name: "Vashi to Wanowrie Cab",
description: "Vashi to Wanowrie cab service provides reliable travel between Navi Mumbai and Pune’s Wanowrie area. This service is popular among residents and professionals traveling between the two cities."
},
{
name: "Vashi to Pune Sedan Cab",
description: "Vashi to Pune sedan cab service offers affordable and comfortable travel for individuals and small groups. Sedan cars like Swift Dzire provide smooth rides and good mileage, making them a budget-friendly option."
},
{
name: "Vashi to Pune Innova Crysta",
description: "Vashi to Pune Innova Crysta cab service offers premium SUV travel with extra comfort and space. It is ideal for corporate clients, families, and long-distance travelers seeking luxury travel experience."
},
{
name: "Vashi to Aundh Cab",
description: "Vashi to Aundh cab service provides direct transportation to Pune’s Aundh area. Travelers can enjoy comfortable rides with professional drivers ensuring safe and timely travel."
},
{
name: "Cab Service in Vashi",
description: "Cab service in Vashi offers reliable transportation for local travel, airport transfers, and outstation trips. Travelers can book a wide range of vehicles with experienced drivers ensuring safe journeys."
},
{
name: "Vashi to Pune Station Cabs Service",
description: "Vashi to Pune station cab service provides direct transportation to Pune railway station. This service is ideal for passengers traveling by train and requiring convenient pickup and drop facilities."
},
{
name: "Taxi Service in Navi Mumbai",
description: "Taxi service in Navi Mumbai provides dependable travel options across Vashi, Nerul, Airoli, and nearby areas. Travelers can book taxis for city rides, airport transfers, and outstation journeys."
},
{
name: "Outstation Cab Booking in Vashi",
description: "Outstation cab booking in Vashi offers easy access to long-distance travel services including Pune, Nashik, Lonavala, and more. Travelers can book online with instant confirmation and transparent pricing."
},
{
name: "Vashi to Pune Cabs",
description: "Vashi to Pune cabs provide reliable intercity transportation with comfortable vehicles and professional drivers ensuring safe travel."
},
{
name: "Vashi to Pune Cab Service",
description: "Vashi to Pune cab service ensures smooth and convenient travel with flexible pickup options and well-maintained vehicles."
},
{
name: "Vashi to Pune Taxi Service",
description: "Vashi to Pune taxi service offers dependable travel with experienced drivers and comfortable vehicles for a pleasant journey."
},
{
name: "Vashi to Pune One Way Cab",
description: "Vashi to Pune one way cab service provides cost-effective travel for passengers requiring single-direction trips."
},
{
name: "Vashi to Pune Taxi Fare",
description: "Vashi to Pune taxi fare provides transparent pricing helping travelers plan their journey efficiently."
},
{
name: "Vashi to Pune Cab Booking",
description: "Vashi to Pune cab booking allows passengers to reserve taxis online with instant confirmation and flexible schedules."
},
{
name: "Cab from Vashi to Pune",
description: "Cab from Vashi to Pune offers safe and reliable transportation with professional drivers and comfortable vehicles."
},
{
name: "Vashi to Pune Car Rental",
description: "Vashi to Pune car rental service provides flexible vehicle options for intercity travel with comfort and convenience."
},
{
name: "Vashi to Pune Taxi Booking Online",
description: "Vashi to Pune taxi booking online allows travelers to book cabs instantly with transparent pricing and quick confirmation."
},
{
name: "Cheap Cab Vashi to Pune",
description: "Cheap cab Vashi to Pune service offers budget-friendly travel with reliable vehicles and professional drivers ensuring safe journeys."
},
{
name: "Vashi to Pune Outstation Cab",
description: "Vashi to Pune outstation cab service provides dependable long-distance travel with comfortable vehicles and experienced drivers."
},
{
name: "Vashi to Pune AC Taxi Service",
description: "Vashi to Pune AC taxi service ensures comfortable air-conditioned travel for long-distance journeys with smooth and relaxing rides."
}
],

tableData: [
["Vashi to Pune Cab","Vashi to Pune Taxi Fare"],
["Vashi to Pune Taxi Service","Vashi to Pune One Day Cab"],
["Vashi to Pune Round Trip Cab","Vashi to Pune Ertiga Cab"],
["Vashi to Pimpri Chinchwad Cab","Vashi to Wanowrie Cab"],
["Vashi to Pune Sedan Cab","Vashi to Pune Innova Crysta"],
["Vashi to Aundh Cab","Cab Service in Vashi"],
["Vashi to Pune Station Cabs Service","Taxi Service in Navi Mumbai"],
["Outstation Cab Booking in Vashi","Vashi to Pune Cabs"],
["Vashi to Pune Cab Service","Vashi to Pune Taxi Service"],
["Vashi to Pune One Way Cab","Vashi to Pune Taxi Fare"],
["Vashi to Pune Cab Booking","Cab from Vashi to Pune"],
["Vashi to Pune Car Rental","Vashi to Pune Taxi Booking Online"],
["Cheap Cab Vashi to Pune","Vashi to Pune Outstation Cab"],
["Vashi to Pune AC Taxi Service","Vashi to Pune Cab"]
],




whychoose: [
  {
    WhyChooseheading: "Experienced Expressway Drivers",
    WhyChoosedescription: "Velocity Cabs provides experienced drivers who regularly travel from Vashi to Pune via the Mumbai Pune Expressway. Their knowledge of highway routes and traffic conditions ensures safe and timely intercity travel."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Velocity Cabs offers transparent and affordable pricing for Vashi to Pune cab bookings. Customers receive clear fare details including toll charges and driver allowance before confirming the ride."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Vashi to Pune cab service operates 24 hours a day. Whether you need an early morning ride, business travel, airport transfer, or late night ride, Velocity Cabs ensures reliable transportation anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in the Velocity Cabs fleet are fully air-conditioned, well maintained, and regularly cleaned to provide passengers with a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs offers flexible travel options including one-way cab service, round-trip bookings, airport transfers, and customized travel plans from Vashi to Pune."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Velocity Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for individuals, families, and corporate travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup in Vashi",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, railway stations, and residential areas across Vashi including Sector 17, Sector 19, Sector 30, and nearby Navi Mumbai locations."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Vashi to Pune cab bookings thanks to punctual drivers, comfortable vehicles, and professional intercity travel service."
  }
]
};

const faqData = [
  { question: "Do you provide Vashi to Pune cab service?", answer: "Yes, Velocity Cabs provides reliable cab services from Vashi to Pune with professional drivers and comfortable vehicles." },
  { question: "How far is Vashi from Pune?", answer: "The road distance between Vashi and Pune is approximately 130 km and the journey usually takes about 2.5 to 3 hours depending on traffic." },
  { question: "Is Vashi to Pune cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 to match customer travel schedules." },
  { question: "Which vehicles are available for Vashi to Pune travel?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way cab from Vashi to Pune?", answer: "Yes, we provide both one-way and round-trip cab services between Vashi and Pune." },
  { question: "Do you provide pickup from homes and hotels?", answer: "Yes, our drivers provide doorstep pickup from homes, hotels, offices, railway stations, and residential areas across Vashi." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Velocity Cabs are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can I book the cab online?", answer: "Yes, customers can easily book Vashi to Pune cab services online or through phone booking." },
  { question: "Do you provide drop service to Pune Airport or railway station?", answer: "Yes, Velocity Cabs provides drop services to Pune Airport, railway stations, and major locations across Pune." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohit Jadhav",
    feedback:
      "Vashi to Pune cab service with Velocity Cab was smooth and comfortable. The vehicle was clean, well-maintained, and the journey felt safe throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Mehta",
    feedback:
      "The Vashi to Pune cab ride with Velocity Cab was very reliable. The driver was professional, and the overall travel experience was hassle-free and punctual.",
    rating: 5
  }
];































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];









const vashiToPuneJSON = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Vashi to Pune Cab Service | Velocity Cabs",
  "description": "Book reliable Vashi to Pune cab with Velocity Cabs. Cars available: Innova, Sedan, Ertiga. One-way, round trips, and AC taxi options. Affordable fares with 24x7 service.",
  "provider": {
    "@type": "Organization",
    "name": "Velocity Cabs",
    "url": "https://www.velocitycabs.com/"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Vashi, Navi Mumbai, Maharashtra, India"
  },
  "serviceType": [
    "Vashi to Pune Taxi",
    "One-way Cab Vashi to Pune",
    "Round Trip Cab Service",
    "Outstation Taxi",
    "AC Taxi Service"
  ],
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  }
};









  return (
    <div>
      
<Helmet>
  <title>Vashi to Pune Cab Service | Velocity Cabs +91 9136271336</title>
  <meta
    name="description"
    content="Book reliable Vashi to Pune cab with Velocity Cabs. Innova, Sedan, Ertiga available for one-way, round trip, and AC taxi options. Affordable fares & 24x7 service."
  />
  <script type="application/ld+json">
    {JSON.stringify(vashiToPuneJSON)}
  </script>
</Helmet>

 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/63.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Vashitopunecab;